import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { sessionFeatureKey, sessionReducer } from './session.reducer';
import { SessionEffects } from './session.effects';

export const SessionFeatureProviders = [
  provideState(sessionFeatureKey, sessionReducer),
  provideEffects(SessionEffects),
];
